<script setup>
defineProps({
  items: {
    type: Array,
    default: () => [],
  },
})

const formatCurrency = (value) => {
  return new Intl.NumberFormat('th-TH', {
    style: 'currency',
    currency: 'THB',
    minimumFractionDigits: 0,
  }).format(value || 0)
}

const formatDate = (value) => {
  if (!value) return '-'
  return new Intl.DateTimeFormat('th-TH', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  }).format(new Date(value))
}
</script>
<template>
  <div class="card border-0 shadow-sm rounded-4 h-100">
    <div class="card-body p-4">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <div>
          <h5 class="fw-bold mb-1">ประวัติการชำระเงิน</h5>
          <div class="text-muted small">รายการรับชำระย้อนหลังของยูนิตนี้</div>
        </div>
        <span class="badge text-bg-light border text-dark rounded-pill px-3 py-2">
          {{ items.length }} รายการ
        </span>
      </div>

      <div class="table-responsive">
        <table class="table align-middle mb-0">
          <thead class="table-light">
            <tr>
              <th>เลขที่รับชำระ</th>
              <th>วันที่ชำระ</th>
              <th>ช่องทาง</th>
              <th class="text-end">จำนวนเงิน</th>
              <th>เลขที่ใบเสร็จ</th>
            </tr>
          </thead>
          <tbody v-if="items.length">
            <tr v-for="payment in items" :key="payment.id">
              <td class="fw-semibold">{{ payment.id }}</td>
              <td>{{ formatDate(payment.date) }}</td>
              <td>{{ payment.method }}</td>
              <td class="text-end text-success fw-semibold">
                {{ formatCurrency(payment.amount) }}
              </td>
              <td>{{ payment.receiptNo }}</td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="5" class="text-center py-5 text-muted">
                <i class="bi bi-cash-stack fs-2 d-block mb-2"></i>
                ยังไม่มีประวัติการชำระเงิน
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
